export const SEATING_TYPE_SECTION = 'SEATING_TYPE_SECTION';
export const SEATING_TYPE_SEATS = 'SEATING_TYPE_SEATS';
export const SEATING_TYPE_GENERALADMISSION = 'SEATING_TYPE_GENERALADMISSION';